module.exports = __webpack_public_path__ + "static/header-bg-6e23fc9ff3e7f2508a1bb7c671dec492.jpg";